import React from 'react';
import CustomLink from "./UI/CustomLink";
import moment from "moment";
import {useSelector} from "react-redux";

const CollectionCard = ({collection}) => {
    const createdDate = moment(collection.created).utc().format('DD MMM YYYY');
    const {
        language,
    } = useSelector((state) => state.language);

    return (
        <div className="collection-card" key={collection.id}>
            <CustomLink href="/collection/[slug]" as={`/collection/${collection.slug}`}>
                <div className="collection-card__banner">
                    {collection.asset.banner && (
                        <img src={collection.asset.banner}/>
                    )}
                </div>
                <div className="collection-card__info">
                    <div className="collection-logo">
                        <img src={collection.asset.logo} alt={collection.name}/>
                    </div>
                    <div className="collection-name">
                        {collection.name}
                    </div>
                    <div className="created-date">
                        {language === 'ru-RU' ? 'Дата создания' : 'Created on'}: <span>{createdDate}</span>
                    </div>
                    <div className="collection-desc">
                        <p>
                            {collection.description}
                        </p>
                    </div>
                </div>
            </CustomLink>
        </div>
    );
};


export default CollectionCard;
